import Layout from "../components/layout";
import Logo from "../components/logo";

export default function Privacy() {
  return (
    <Layout>
      <Logo />
      <h2>Privacy Policy</h2>
      <div>
        <p>
          The <a href="https://slack.com/apps/A0159PRF41X">Lockbot Slack App</a>
          :
        </p>
        <ol>
          <li>asks for the minimum scopes necessary</li>
          <li>and only stores the data that is required</li>
        </ol>
        <p>
          to provide its{" "}
          <a href="https://github.com/connorads/lockbot/blob/master/README.md">
            advertised functionality.
          </a>
        </p>
      </div>
      <p style={{ textAlign: "center" }}>
        We will not sell or share the limited personal data that is kept.
      </p>
      <p style={{ textAlign: "center" }}>
        Feel free to look at the{" "}
        <a href="https://github.com/connorads/lockbot">source code</a> and see
        👀
      </p>
      <p>
        <i>Effective date: 24th June 2020</i>
      </p>

      <style jsx>{`
        p,
        ol {
          margin-block-start: 0.75em;
          margin-block-end: 0.75em;
        }
      `}</style>
    </Layout>
  );
}
